import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../../Layout/Footer';
import Header from '../../Layout/Header';
import userdetails from "../../../assets/img/user-details.jpg";
import userimg from '../../../assets/img/user-img.png';
import { useRef } from 'react';
import { fetchServices, updateSignUpUserDetails } from '../../../Redux/User/action';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import ToasterMessage from '../../ToasterMessage';
import { setUserLoginDetails } from '../../../slices/user/userSlice';
import { ToastContainer, toast } from 'react-toastify';


const UserDetails = () => {

    const ref = useRef("");
    const navigate = useNavigate();
    const [toaster, setToaster] = useState("");
    const [services, setServices] = useState();
    useEffect(() => {
        fetchServices()((response) => {
            if (response && response.status) {
                setServices(response?.data)
            }
        });
    }, []);
    const validationSchema = Yup.object().shape({

        primary_service: Yup.string()
            .required('Required'),
        secondary_service: Yup.string()
            .required('Required'),
        about: Yup.string()
            .required('Required'),
        experience: Yup.string()
            .required('Required'),
    });
    const formik = useFormik({
        initialValues: {
            primary_service: "",
            secondary_service: "",
            experience: "",
            about: "",

        },
        validationSchema,
        onSubmit: (values) => {
            let formData = new FormData();
            formData.append("primary_service", values.primary_service);
            formData.append("secondary_service", values.secondary_service);
            formData.append("experience", values.experience);
            formData.append("about_user", values.about);
            // localStorage.setItem('token', localStorage.getItem('token_temp'));
            updateSignUpUserDetails({ formData })((response) => {
                if (response && response.status) {
                    toast.success("Success", {
                        position: toast.POSITION.TOP_RIGHT
                    });
                    // setToaster("Success");
                    // setTimeout(() => {
                    //     setToaster("");
                    // }, 2000);
                    navigate('/bankaccountdetails')
                }
                else {

                    toast.error(response.response.data?.data?.errors?.about_user[0], {
                        position: toast.POSITION.TOP_RIGHT
                    });
                    // setToaster("Error");
                    // setTimeout(() => {
                    //     setToaster("");
                    // }, 2000);
                }
            });
        },
    });

    const remainingChars = 250 - formik.values.about.length;

    return (
        <React.Fragment>
            <ToastContainer />
            {/* <ToasterMessage toaster={toaster} setToaster={setToaster} /> */}
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>
                                    Enter Your Details </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Enter Your Details</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="user-details">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <img src={userdetails} alt="" className="img-fluid" />
                        </div>
                        <div className="col-lg-6">
                            <div className="userdetails-form">
                                <Form onSubmit={formik.handleSubmit}>
                                    {/* <div onClick={() => ref.current.click()} className="avatar-wrapper">
                                        <img className="profile-pic" src={userimg} alt='User' />
                                        <input ref={ref} className="file-upload" type="file" accept="image/*" />
                                    </div> */}
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Primary Service <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                        <Form.Select name='primary_service' required onChange={formik.handleChange}>
                                            <option value="">Add Services</option>
                                            {services?.map((service) =>
                                                <option value={service?.pk}>{service?.name}</option>
                                            )}

                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Secondary Services <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                        <Form.Select name='secondary_service' required onChange={formik.handleChange}>
                                            <option>Add Services</option>
                                            {services?.map((service) =>
                                                <option value={service?.pk}>{service?.name}</option>
                                            )}
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Experience <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                        <Form.Control
                                            type="number"
                                            name='experience'
                                            onChange={formik.handleChange}
                                            required
                                            placeholder="Enter Your Experience in Years"
                                        />

                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                        <Form.Label>About Yourself <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                        <Form.Control
                                            name='about'
                                            onChange={formik.handleChange}
                                            as="textarea"
                                            rows={3}
                                            maxLength={250}
                                            required
                                        />
                                        <p style={{ color: "#012970", fontWeight: "700" }}>{formik.values.about.length}/ {250}</p>
                                    </Form.Group>

                                    <div className="userdetails-form-btn">
                                        <Button type="submit" className="btn btn-primary next-btn mt-3 mb-3">Continue</Button>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    )
}

export default UserDetails;